import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import { GlobalService } from '../global/global.service';
import { TraspasoStoreService } from './traspaso-store.service';


interface IFounds {
  datos: { listaFondoClass: { codigoMoneda: string; claseFondo: string }[] };
}

interface IViaPay {
  datos: { viasDePagos: [] }
}

interface IRescue {
  datos: { rescate: [] }, resultado: [] 
}

@Injectable({
  providedIn: 'root',
})
export class TraspasoRequestsService {
  constructor(
    private http: HttpClient, 
    private globalService: GlobalService, 
    public traspasoStore: TraspasoStoreService
    ) {}

    getFoundsDestination(params): Observable<any> {
      return this.http
        .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/traspaso/private/listarFondosDestino/${params.cucDestino}`)
        .pipe(map((apiResponse: IFounds) => this.mapGetFoundsDestination(apiResponse)));
    }
  
    mapGetFoundsDestination(apiResponse: { datos: { fondos: [] } } | any) {
      if(apiResponse.datos && apiResponse.datos.fondos){
        return apiResponse.datos;
      }
      return [];
    }

    getFoundsOrigin(params): Observable<any> {
      return this.http
        .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/traspaso/private/listarFondosOrigen/${params.cuc}`)
        .pipe(map((apiResponse: IFounds) => this.mapGetFoundsOrigin(apiResponse)));
    }
  
    mapGetFoundsOrigin(apiResponse: { datos: { fondos: [] } } | any) {
      if(apiResponse.datos && apiResponse.datos.fondos){
        return apiResponse.datos.fondos;
      }
      return [];
    }
  
    validateTraspaso(params): Observable<any> {
      return this.http
        .post(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/traspaso/private/validarTraspaso`, params)
    }
  
    saveTraspaso(params): Observable<any> {
      return this.http
        .post(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/traspaso/private/grabarTraspaso`, params)
    }

    sendMail(params): Observable<any> {
      return this.http
        .post(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/traspaso/private/enviarMail/${params}`,'')
    }
  
    resetTraspasoData() {
      this.traspasoStore.TRASPASO_FONDS_DESTINATION= []
      this.traspasoStore.TRASPASO_FONDS_ORIGIN= []
      delete this.traspasoStore.TRASPASO_DATA
      delete this.traspasoStore.TRASPASO_CONFIRM_DATA
    }

}
